import BigNumber from 'bignumber.js';
import Vue from 'vue';
import store from '../store';
import axios from 'axios';

class SaveService {
    constructor() {
        this.clean = false;
    }

    /**
     * save current gamestate to localstorage and - if the user is logged in - to db
     */
    saveState() {
        if (this.clean) {
            return;
        }
        let shopsToSave         = [],
            achievementsToSave  = [],
            upgradesToSave      = [],
            managersToSave      = [],
            buildIncrement      = store.state.game.buildIncrement,
            hideAppliedUpgrades = store.state.game.hideAppliedUpgrades,
            data;
        // saving "max" as increment may cause serious problems when coming back and having earned a lot of money
        buildIncrement = buildIncrement < 1 || isNaN(parseInt(buildIncrement, 10)) ? 1 : buildIncrement;
        store.getters.allShops.forEach(shop => {
            shopsToSave.push({
                id:                      shop.id,
                name:                    shop.name,
                amount:                  shop.amount,
                hasManager:              shop.hasManager,
                manager:                 shop.manager,
                coolDown:                shop.coolDown,
                earningsMultiplier:      shop.earningsMultiplier,
                costMultiplier:          shop.costMultiplier,
                isProducing:             Object.prototype.hasOwnProperty.call(shop, 'isProducing')
                    ? shop.isProducing
                    : false,
                productionTimeRemaining: Object.prototype.hasOwnProperty.call(shop, 'productionTimeRemaining')
                    ? shop.productionTimeRemaining
                    : 0
            });
        });

        store.getters.allAchievements.forEach(achievement => {
            if (achievement.isAchieved) {
                achievementsToSave.push({
                    id:         achievement.id,
                    isAchieved: true,
                    date:       achievement.date,
                    name:       achievement.name
                });
            }
        });

        store.getters.allUpgrades.forEach(upgrade => {
            if (upgrade.isApplied) {
                upgradesToSave.push({ id: upgrade.id, isApplied: true });
            }
        });

        store.getters.allManagers.forEach(manager => {
            if (manager.isHired) {
                managersToSave.push({ id: manager.id, isHired: true });
            }
        });
        data = {
            timestamp:        Date.now(),
            achievements:     achievementsToSave,
            shops:            shopsToSave,
            upgrades:         upgradesToSave,
            managers:         managersToSave,
            balance:          store.state.game.balance.toString(),
            lifetimeEarnings: store.state.game.lifetimeEarnings.toString(),
            lang:             Vue.i18n.locale(),
            version:          store.state.game.version,
            statsID:          store.state.game.statsID, // @todo x3
            tutorialStep:     store.state.tutorial.step,
            hideAppliedUpgrades,
            buildIncrement
        };
        if (store.state.onStrike) {
            data.strikeDuration = store.state.strikeDuration;
        }
        if (store.state.game.user._id > 0) {
            axios.put(`${store.state.game.apiURL}/api/gamestate/${store.state.game.user._id}`, {
                data
            })
                .then(response => {
                    console.log('Pushed to server, got response: ', response);
                })
                .catch(response => {
                    console.error('Could not save to server: ', response);
                });
        }
    }

    /**
     * restore the loaded gamestate
     *
     * @param loadedData
     * @returns {boolean}
     */
    restoreState(loadedData) {
        // try to load data from localstorage/db
        if (typeof loadedData === 'undefined' || !Object.prototype.hasOwnProperty.call(loadedData, 'timestamp')) {
            return false;
        }
        if (Vue.i18n.locale() !== loadedData.lang) {
            Vue.i18n.set(loadedData.lang);
        }
        if (typeof loadedData.lifetimeEarnings === 'undefined') {
            loadedData.lifetimeEarnings = 0;
        }
        let goneForSeconds         = Math.floor((Date.now() - loadedData.timestamp) / 1000),
            secondsForProduction   = goneForSeconds;
        store.commit('SET_BALANCE', { amount: new BigNumber(loadedData.balance.toString()) });
        store.commit('SET_LIFETIME_EARNINGS', { amount: new BigNumber(loadedData.lifetimeEarnings.toString()) });
        store.commit('SET_LANGUAGE', { language: loadedData.lang });
        store.commit('SET_BUILD_INCREMENT', loadedData.buildIncrement);
        store.commit('SET_STATS_ID', { id: loadedData.statsID });
        store.commit('MERGE_MANAGERS', { managers: loadedData.managers });
        store.commit('MERGE_SHOPS', { shops: loadedData.shops });
        store.commit('MERGE_UPGRADES', { upgrades: loadedData.upgrades });
        store.commit('MERGE_ACHIEVEMENTS', { achievements: loadedData.achievements });
        store.commit('TOGGLE_HIDE_APPLIED_UPGRADES', loadedData.hideAppliedUpgrades);
        store.commit('SET_STEP', loadedData.tutorialStep);
        store.commit('CALCULATE_INCOME_WHILE_GONE', { secondsForProduction });
        return true;
    }

    /**
     * get user's last saved gamestate from db
     *
     * @param user
     */
    loadStateFromDB(user) {
        if (this.clean || !Object.prototype.hasOwnProperty.call(user, '_id')) {
            return;
        }
        axios.get(`${store.state.game.apiURL}/api/gamestate/${store.state.game.user._id}`, {})
            .then(data => {
                this.restoreState(data);
            })
            .catch(error => {
                console.error('Error: ', error);
            });
    }

    /**
     * clear localstorage
     *
     * @returns {*}
     */
    clearAll() {
        return Vue.localStorage.remove('lastOnline');
    }

    initReset() {
        store.commit('INIT_RESET');
        store.commit('SAVE_GAME');
        if (store.state.game.user._id > 0) {
            axios.delete(`${store.state.game.apiURL}/api/gamestate/${store.state.game.user._id}`)
                .then(response => {
                    console.log('cleared... ', response);
                });
        }
        this.clean = true;
        this.clearAll();
        window.location.reload();
    }
}

export default new SaveService();
